<script>
import {
  Popup,
  Icon,
  Tabs,
  Tab,
  showLoadingToast,
  closeToast,
} from 'vant'
import {mapState, mapGetters, mapActions} from 'vuex'
import {getTCConsultant, getMomentDetailIdByCarId} from '@api'
import ConsultantCard from '@components/consultant-card.vue'
import Loading from '@components/loading.vue'
import {globalImagePlaceholder} from '@constants'
import IconBase from '@icons/IconBase'
import IconPhoneCall from '@icons/IconPhoneCall'
import Brand from './components/brand.vue'
import Comments from './components/comments.vue'
import Description from './components/description.vue'
import GallerySwiper from './components/gallery-swiper.vue'
import Toolbar from './components/gallery-toolbar.vue'
import MetaInfo from './components/meta-info.vue'
import NavigatorToZcarIndex from './components/navigator-to-zcar-index.vue'
import StandardReportEquipment from './components/report-equipment.vue'
import Reports from './components/reports.vue'
import Warranty from './components/warranty'
import 'vant/lib/toast/style'

export default {
  name: 'StandardDetail',

  // component
  components: {
    Loading,
    NavigatorToZcarIndex,
    GallerySwiper,
    Toolbar,
    MetaInfo,
    Description,
    Reports,
    Warranty,
    Brand,
    Comments,
    StandardReportEquipment,
    ConsultantCard,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    IconBase,
    IconPhoneCall,
  },

  // beforeRouteEnter
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      vm.loading = true
      await vm.loadCar({
        id: to.params.id,
      })
      vm.loading = false
    })
  },

  // beforeRouteUpdate
  async beforeRouteUpdate (to, from, next) {
    this.loadCar({
      id: to.params.id,
    })

    next()
  },

  props: {},

  data () {
    return {
      // image placehoder
      globalImagePlaceholder: globalImagePlaceholder,
      // popupOfConsultantCardShouldDisplay
      popupOfConsultantCardShouldDisplay: false,
      // activeTab
      activeTab: '车辆档案',
      // matchMediaMinWidth640
      matchMediaMinWidth640: false,
      // loading
      // - 2023.08.10
      // - ui control
      loading: false,
      // consultantOfHunt
      consultantOfHunt: null,
      // photoGalleryShouldBeVisible
      photoGalleryShouldBeVisible: false,
      // targetOfImageGallery
      targetOfImageGallery: null,
      // pictures
      pictures: [],
      // optionsListExpanded
      // - 2025.02.07
      // - Options list should be expand
      optionsListExpanded: true,
      // commentsExpanded
      // - 2025.02.07
      // - Comments should be expanded
      commentsExpanded: false,
      // optionsListContent
      optionsListContent: null,
      // shouldShowOptionsToggle
      shouldShowOptionsToggle: false,
      // showTagsPopup
      // - 2025.06.21
      // - Controls visibility of tags detail popup
      showTagsPopup: false,
    }
  },

  computed: {
    ...mapState('Car', {
      merchandise: state => state.merchandise,
    }),

    ...mapGetters('Car', [
      'carByCarId',
      'typeByCarId',
      'priceByCarId',
      'tagsByCarId',
      'consultantByCarId',
      'loanOfficerByCarId',
      'notesByCarId',
      'picSumnaryByCarId',
      'commentsByCarId',
      'coverByCarId',
      'imagesGroupedByCategoryByCarId',
      'imagesGroupByCategoryFlattedbyCarId',
      'recommendsByCarId',
      'keyByCarId',
      'reportEquipmentById',
      'isMotorcycleById',
      'newEnergyByCarId',
      'titleByCarId',
      'releaseTypeByCarId',
      'categoryByCarId',
    ]),

    ...mapGetters('Application', [
      'wechat',
    ]),

    carId () {
      return this.$route.params.id
        ? this.$route.params.id
        : null
    },

    // consultant
    consultant () {
      if (this.releaseType === '已预定'){
        return this.consultantOfHunt
      }
      else {
        return this.consultantByCarId(this.carId)
      }
    },

    car () {
      return this.carByCarId(this.carId)
    },

    type () {
      return this.typeByCarId(this.carId)
    },

    price () {
      return this.priceByCarId(this.carId)
    },

    tags () {
      return this.tagsByCarId(this.carId)
    },

    notes () {
      return this.notesByCarId(this.carId)
    },

    picSumnary () {
      return this.picSumnaryByCarId(this.carId)
    },

    comments () {
      return this.commentsByCarId(this.carId)
    },

    loanOfficer () {
      return this.loanOfficerByCarId(this.carId)
    },

    cover () {
      return this.coverByCarId(this.carId)
    },

    imagesGroupedByCategory () {
      return this.imagesGroupedByCategory(this.carId)
    },

    imagesGroupByCategoryFlatted () {
      return this.imagesGroupByCategoryFlattedbyCarId(this.carId)
    },

    recommends () {
      return this.recommendsByCarId(this.carId)
    },

    // 车辆-钥匙编号
    key () {
      return this.keyByCarId(this.carId)
    },

    // 图文笔记
    hasComments () {
      return this.comments && this.comments.length > 0
    },

    // reportEquipment
    reportEquipment () {
      return this.reportEquipmentById(this.carId)
    },

    // isMotocycleById
    isMotorcycle () {
      return this.isMotorcycleById(this.carId)
    },

    // newEnergy
    newEnergy () {
      return this.newEnergyByCarId(this.carId)
    },

    // title
    title () {
      return this.titleByCarId(this.carId)
    },

    // releaseType
    releaseType () {
      return this.releaseTypeByCarId(this.carId)
    },

    // category
    category () {
      return this.categoryByCarId(this.carId)
    },

    // hasTagsWithDesc
    // - 2025.05.21
    // - Whether any tag has description
    hasTagsWithDesc () {
      return this.car?.car?.tags?.some(tag => tag.desc)
    },

    // tagsWithDesc
    // - 2025.05.21
    // - Filtered tags that have description
    tagsWithDesc () {
      return this.car?.car?.tags?.filter(tag => tag.desc)
    },

    tagObjects () {
      // car.car.tags may be array of strings or objects with attributes
      return (this.car?.car?.tags || []).map((tag) => {
        if (typeof tag === 'string') {
          return {
            name: tag,
            is_highlight: false,
          }
        }

        return tag
      })
    },
  },

  mounted () {
    const mm = window.matchMedia('(min-width: 640px)')

    this.matchMediaMinWidth640 = mm.matches

    mm.addEventListener('change', (e) => {
      this.matchMediaMinWidth640 = e.matches
    })
  },

  methods: {
    ...mapActions('Car', [
      'fetchCar',
      'fetchEquipment',
      'fetchRecommends',
      'fetchMerchandise',
    ]),

    // calcOptionsListHeight
    // - 2025.02.10
    // - Calculates the height of the options list content and determines if toggle should be shown
    // - Loads optional configuration images asynchronously
    // - Measures content height after images load
    // - Shows toggle button if content exceeds 500px height
    // - Maintains expand/collapse state
    async calcOptionsListHeight () {
      if (this.car?.car?.optional_configuration_images?.length) {
        await Promise.all(
          this.car.car.optional_configuration_images.map(imgSrc => {
            return new Promise((resolve) => {
              const img = new Image()

              img.onload = resolve
              img.onerror = resolve
              img.src = `${imgSrc}!/fw/960/rotate/auto/format/webp`
            })
          }),
        )

        setTimeout(() => {
          const content = this.$refs.optionsListContent

          if (content) {
            const optionsListContentHeight = content.clientHeight

            if (optionsListContentHeight > 500) {
              this.shouldShowOptionsToggle = true
              this.optionsListExpanded = false
            }
            else {
              this.shouldShowOptionsToggle = false
              this.optionsListExpanded = true
            }
          }
        }, 300)
      }
    },

    // loadCar
    async loadCar (params) {
      const id = params.id || this.$route.params.id
      const fetchingCar = this.fetchCar({
        params: {
          id:  id,
          mode: this.mode,
        },
      })

      const fetchingRecommends = this.fetchRecommends({
        params: {
          id:  id,
          mode: this.mode,
        },
      })

      const fetchingEquipment = this.fetchEquipment({
        params: {
          module_id: id,
          business: 'zyc',
          approval_id: 0,
          mode: 'release',
          vehicle_inspection_report_id: 1,
          ...this.$route.query,
        },
      })

      const fetchingMerchandise = this.fetchMerchandise()

      await fetchingCar
      await fetchingRecommends
      await fetchingEquipment
      await fetchingMerchandise

      if (this.releaseType === '已预定') {
        const _consultant = await getTCConsultant()

        this.consultantOfHunt = {
          ..._consultant,
          qr_code: _consultant.qrcode || null,
        }
      }

      this.car && this.car.title && (document.title = this.car.title)
      this.activeTab = '车辆档案'

      this.calcOptionsListHeight()
    },

    // consultantDidCall
    // - Tracks consultant call event in analytics
    consultantDidCall () {
      // growing.io
      gio(`track`, `zyc_h5_2_2_call_consultant`, {
        car_id: this.car.id,
        car_title: this.car.title,
        car_status: this.car.status,
        consultant_name: this.consultant.name,
        action_source: `车辆详情`,
      })
    },

    // orderSameCarBtnDidPress
    // - Handles click event for "Order Same Car" button
    // - Shows consultant card popup
    orderSameCarBtnDidPress () {
      this.popupOfConsultantCardShouldDisplay = true
    },

    // vehicleRatingReferenceBtnDidPress
    // - Opens vehicle rating reference image
    // - Uses platform-specific preview methods for WeChat/DingTalk
    // - Falls back to standard image gallery
    vehicleRatingReferenceBtnDidPress () {
      const target = 'https://static.nuonuo.com.cn/zycmp/report-inspection-rating-rules-20250709.png'

      if (this.$store.getters['Application/wechat'] || this.$store.getters['Application/wework']) {
        wx.previewImage({
          current: target,
          urls: [target],
        })
      }
      else if (this.$store.getters['Application/douyin']) {
        tt.miniProgram.previewImage({
          current: target,
          urls: [target],
        })
      }
      else {
        this.targetOfImageGallery = target
        this.pictures = [target]
        this.photoGalleryShouldBeVisible = true
      }
    },

    // optionsListImageDidPress
    // - 2025.02.10
    // - Options list image did press
    optionsListImageDidPress (e) {
      const target = e.currentTarget.dataset.src
      const images = this.car.car.optional_configuration_images

      if (this.$store.getters['Application/wechat'] || this.$store.getters['Application/wework']) {
        wx.previewImage({
          current: target,
          urls: images,
        })
      }
      else if (this.$store.getters['Application/douyin']) {
        tt.miniProgram.previewImage({
          current: target,
          urls: images,
        })
      }
      else {
        this.targetOfImageGallery = target
        this.pictures = images
        this.photoGalleryShouldBeVisible = true
      }
    },

    // navigateToVehicleCommentsDetail
    // - 2025.05.31
    // - Navigates to vehicle comments (road-test notes) detail page
    // - Fetches moment post id by current car id via API and routes to post detail page
    async navigateToVehicleCommentsDetail () {
      try {
        const etId = this.car?.etId

        if (!etId) {
          window.alert('暂无路试笔记')

          return
        }

        showLoadingToast({
          message: '加载中...',
          forbidClick: true,
        })

        const rb = await getMomentDetailIdByCarId({
          params: {
            UD: etId,
          },
        })

        closeToast()

        if (rb?.id) {
          this.$router.push({
            name: 'NuoMomentPostDetail',
            params: {
              postId: rb.id,
            },
          })
        }
        else {
          window.alert('暂无路试笔记')
        }
      }
      catch (err) {
        closeToast()

        window.alert(err?.message || '获取路试笔记失败')
      }
    },

    // tagsListDidPress
    // - 2025.06.21
    // - Handle click on tags list to open detail popup
    tagsListDidPress () {
      if (this.hasTagsWithDesc) {
        this.showTagsPopup = true
      }
    },

    // closeTagsPopup
    // - 2025.06.21
    // - Close tags detail popup
    closeTagsPopup () {
      this.showTagsPopup = false
    },
  },
}

</script>

<template>
  <!-- car wrapper START -->
  <div class="page-wrapper page-wrapper--standard-detail">
    <van-popup
      v-model:show="popupOfConsultantCardShouldDisplay"
      :class="['popup-of-consultant-card']"
      :duration="0">
      <van-icon
        :name="'cross'"
        :size="40"
        :class="'close-btn'"
        :color="'#818181'"
        @click.stop.prevent="popupOfConsultantCardShouldDisplay = false" />
      <consultant-card :consultant="consultant" />
    </van-popup>

    <photo-gallery-2
      v-model:visible="photoGalleryShouldBeVisible"
      :target="targetOfImageGallery"
      :images="pictures" />

    <!-- Tags detail popup -->
    <van-popup
      v-model:show="showTagsPopup"
      position="bottom"
      :class="['tags-detail-popup']"
      :duration="0">
      <van-icon
        name="cross"
        size="30"
        class="tags-detail-close-btn"
        @click="closeTagsPopup" />
      <div class="tags-detail-container">
        <div class="tags-detail-body">
          <div class="tags-detail-header">
            <div class="tags-detail-header-title">亮点标签</div>
          </div>
          <div class="tags-detail-body-content">
            <template
              v-for="(tag, idx) in tagsWithDesc"
              :key="idx">
              <div class="tags-detail-item">
                <div class="tags-detail-item-header">
                  <div class="tags-detail-item-icon">
                    <van-icon
                      name="arrow"
                      size="12" />
                  </div>
                  <div class="tags-detail-item-title">{{ tag.name }}</div>
                </div>
                <div class="tags-detail-item-content">
                  <div class="tags-detail-item-desc">{{ tag.desc }}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </van-popup>

    <template v-if="!car">
      <loading />
    </template>
    <template v-else>
      <!-- 顾问信息 START -->
      <template v-if="consultant && consultant.name">
        <div class="consultant-wrapper">
          <div class="consultant">
            <div class="consultant-info-wrapper">
              <div class="consultant-avatar-wrapper">
                <img
                  class="consultant-avatar-el"
                  :src="consultant.avatar"
                  :alt="consultant.name">
              </div>
              <div class="consultant-info">
                <div class="consultant-title">
                  销售顾问
                </div>
                <div class="consultant-name">
                  {{ consultant.name }}
                </div>
              </div>
            </div>

            <div class="consultant-action-wrapper">
              <template v-if="releaseType === '已预定'">
                <div class="consultant-action-wrapper">
                  <div
                    class="consultant-action-button-order-same-car"
                    @click.prevent.stop="orderSameCarBtnDidPress">
                    淘同款
                  </div>
                </div>
              </template>
              <template v-else>
                <div
                  class="consultant-msg-btn-wrapper"
                  @click.prevent.stop="popupOfConsultantCardShouldDisplay = true">
                  <div class="consultant-msg-icon-wrapper">
                    <svg
                      class="consultant-msg-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512">
                      <path d="M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z" /></svg>
                  </div>

                  <div class="consultant-msg-text">
                    在线咨询
                  </div>
                </div>

                <a
                  :href="`tel:${consultant.wechat_mobile}`"
                  class="consultant-call-btn"
                  @click.stop="consultantDidCall">
                  <icon-base
                    class="call-consultant-btn-icon"
                    view-box="0 0 333 333"
                    icon-color="#ff651b">
                    <icon-phone-call />
                  </icon-base>

                  <div class="call-consultant-btn-text">
                    电话咨询
                  </div>
                </a>
              </template>
            </div>
          </div>
        </div>
      </template>
      <!-- 顾问信息 END -->

      <div class="standard-detail-wrapper">
        <!-- 更多自营车按钮 START -->
        <navigator-to-zcar-index />
        <!-- 更多自营车按钮 END -->

        <!-- 买前必读 START -->
        <router-link
          :to="{name: 'ZycAgreement'}"
          class="navigator-to-agreement">
          <div class="text">买前</div>
          <div class="text">必读</div>
        </router-link>
        <!-- 买前必读 END -->

        <div :class="['car-type-cover-wrapper', type]">
          <template
            v-if="imagesGroupByCategoryFlatted
              && imagesGroupByCategoryFlatted.length">
            <div
              :class="['car-gallery-wrapper', type]"
              :style="{
                'minHeight': matchMediaMinWidth640
                  ? '426px'
                  : '250px'
              }">
              <gallery-swiper />
              <toolbar />
            </div>
          </template>
          <template v-else>
            <div class="gallery-placeholder">
              <img
                :src="globalImagePlaceholder"
                :class="['gallery-placeholder-el']"
                alt="">
            </div>
          </template>

          <!--* colored bg wrapper START -->
          <div
            :class="[
              'colored-bg-wrapper',
              newEnergy ? 'new-energy' : ''
            ]">
            <!-- title wrapper START -->
            <template v-if="title">
              <div class="title-wrapper">
                <div class="title">
                  <span class="title__category-indicator">
                    <template v-if="category === 'premium'">
                      精品自营
                    </template>
                    <template v-else-if="category === 'discount'">
                      特价
                    </template>
                  </span>
                  <span class="title-text">{{ title }}</span>
                </div>
              </div>
            </template>
            <!-- title wrapper END -->

            <!-- tags wrapper START -->
            <template v-if="tagObjects && tagObjects.length > 0">
              <div
                :class="['tag-wrapper', { 'new-energy': newEnergy }]"
                @click="tagsListDidPress">
                <template
                  v-for="(tag, tagIndex) in tagObjects"
                  :key="tagIndex">
                  <div
                    :class="['tag-item', { 'tag-item--highlight': tag.is_highlight }]">
                    {{ tag.name }}
                  </div>
                </template>
                <template v-if="hasTagsWithDesc">
                  <van-icon
                    name="arrow"
                    class="tag-info-indicator__icon"
                    size="12" />
                </template>
              </div>
            </template>
            <!-- tags wrapper END -->

            <!-- price-wrapper START -->
            <template v-if="price">
              <div class="price-wrapper">
                <div class="price">
                  {{ price.current }}
                </div>
                <div class="price-info-wrapper">
                  <router-link
                    :to="{name: 'PriceNegotiable'}"
                    :class="'navigator-to-vote'">
                    → 能议价么？←
                  </router-link>

                  <!-- price notice wrapper START -->
                  <template v-if="price.original">
                    <div class="price-notice-wrapper">
                      <div class="price-notice__info-cell">
                        *提档、过户费另计
                      </div>
                      <div class="price-notice__info-delimiter">·</div>
                      <div class="price-notice__info-cell">
                        税前指导价{{ price.original }}万元
                      </div>
                      <template v-if="price.reduce">
                        <div class="price-notice__info-delimiter">·</div>
                        <div class="price-notice__info-cell">节省{{ price.reduce }}万元</div>
                      </template>
                    </div>
                  </template>
                  <!-- price notice wrapper END -->
                </div>
              </div>
            </template>
            <!-- price-wrapper END -->
          </div>
          <!-- colored bg wrapper END -->
        </div>

        <!-- mortgage wrapper -->
        <template v-if="price && price.current !== '待核价'">
          <router-link
            :to="{
              name: 'carLoans',
              params: {
                id: $route.params.id
              }
            }"
            class="mortgage-wrapper">
            <div class="mortgage-promotion-text">
              <div class="emphysis">金融贷款</div>
              <div>服务可覆盖全国，金融专员专人对接</div>
            </div>
            <div class="mortgage-more">
              详情咨询 ›
            </div>
          </router-link>
        </template>
        <!-- mortgage wrapper -->

        <van-tabs
          v-model:active="activeTab"
          :type="'line'"
          :scrollspy="true"
          :sticky="true"
          :lazy-render="false"
          :shrink="true"
          :duration="0"
          :class="['anchor-menu-wrapper']"
          :offset-top="matchMediaMinWidth640 ? 56 : 44">
          <!-- 车况 -->
          <van-tab
            :name="'车况'"
            :title="'车况'">
            <!-- 基本信息 START -->
            <div
              :ref="'metaInfoHD'"
              :class="['heading-wrapper', 'meta-info-heading-wrapper']">
              <h3 class="heading">
                车辆档案
              </h3>
              <!-- eslint-disable -->
              <div :class="['car-serial-number']">
                <template v-if="car.car.vin"> {{ car.car.vin }} </template
                >
              </div>
              <!-- eslint-enable -->
            </div>

            <div
              class="meta-info-wrapper"
              style="padding-right: 0;">
              <meta-info />
            </div>
            <!-- 基本信息 END -->

            <!-- 车源描述 START -->
            <template v-if="notes">
              <div class="heading-wrapper description-heading-wrapper">
                <h3 class="heading">
                  车况描述
                </h3>
              </div>

              <div class="description-wrapper">
                <description />
              </div>

              <div class="seperator" />
            </template>
            <!-- 车源描述 END -->
          </van-tab>
          <!--/ 车况 -->

          <!-- 诺式报告 -->
          <van-tab
            :name="'诺式报告'"
            :title="'诺式报告'">
            <div>
              <template v-if="car.car.car_condition_level && car.car.car_condition_level !== '-'">
                <div
                  class="heading-wrapper reportsheading-wrapper">
                  <h3 class="heading">
                    车身评级
                  </h3>
                </div>

                <div class="vechile-rating-wrapper">
                  <div class="vehicle-rating">
                    <div class="rating-level">
                      <div class="rating-level__items">
                        <!-- N+ -->
                        <div
                          :class="[
                            'rating-level__item-wrapper',
                            car.car.car_condition_level === 'N+' ? 'rating-level__item-wrapper--active' : ''
                          ]">
                          <div class="rating-level__item rating-level__item--n-plus">
                            <div class="rating-level__item__desc">N+</div>
                          </div>
                          <div class="rating-level__item-desc">
                            <div class="rating-level__item-desc__text">原板</div>
                            <div class="rating-level__item-desc__text">原漆</div>
                          </div>
                        </div>
                        <!-- N -->
                        <div
                          :class="[
                            'rating-level__item-wrapper',
                            car.car.car_condition_level === 'N' ? 'rating-level__item-wrapper--active' : ''
                          ]">
                          <div class="rating-level__item rating-level__item--n">
                            <div class="rating-level__item__desc">N</div>
                          </div>
                        </div>
                        <!-- N- -->
                        <div
                          :class="[
                            'rating-level__item-wrapper',
                            car.car.car_condition_level === 'N-' ? 'rating-level__item-wrapper--active' : ''
                          ]">
                          <div class="rating-level__item rating-level__item--n-minus">
                            <div class="rating-level__item__desc">N-</div>
                          </div>
                        </div>
                        <!-- B -->
                        <div
                          :class="[
                            'rating-level__item-wrapper',
                            car.car.car_condition_level === 'B' ? 'rating-level__item-wrapper--active' : ''
                          ]">
                          <div class="rating-level__item rating-level__item--b">
                            <div class="rating-level__item__desc">B</div>
                          </div>
                        </div>
                        <!-- C+ -->
                        <div
                          :class="[
                            'rating-level__item-wrapper',
                            car.car.car_condition_level === 'C+' ? 'rating-level__item-wrapper--active' : ''
                          ]">
                          <div class="rating-level__item rating-level__item--c-plus">
                            <div class="rating-level__item__desc">C+</div>
                          </div>
                        </div>
                        <!-- C -->
                        <div
                          :class="[
                            'rating-level__item-wrapper',
                            car.car.car_condition_level === 'C' ? 'rating-level__item-wrapper--active' : ''
                          ]">
                          <div class="rating-level__item rating-level__item--c">
                            <div class="rating-level__item__desc">C</div>
                          </div>
                        </div>
                        <!-- D+ -->
                        <div
                          :class="[
                            'rating-level__item-wrapper',
                            car.car.car_condition_level === 'D+' ? 'rating-level__item-wrapper--active' : ''
                          ]">
                          <div class="rating-level__item rating-level__item--d-plus">
                            <div class="rating-level__item__desc">D+</div>
                          </div>
                        </div>
                        <!-- D -->
                        <div
                          :class="[
                            'rating-level__item-wrapper',
                            car.car.car_condition_level === 'D' ? 'rating-level__item-wrapper--active' : ''
                          ]">
                          <div class="rating-level__item rating-level__item--d">
                            <div class="rating-level__item__desc">D</div>
                          </div>
                          <div class="rating-level__item-desc">
                            <div class="rating-level__item-desc__text">重大</div>
                            <div class="rating-level__item-desc__text">事故</div>
                          </div>
                        </div>
                      </div>
                      <div class="rating-level__desc">损伤及修复增加</div>
                    </div>
                  </div>

                  <!-- Add back the reference wrapper -->
                  <div class="vehicle-rating-reference-wrapper">
                    <div class="vehicle-rating-reference">
                      * 了解
                      <div
                        class="vehicle-ratinf-reference__link--reference"
                        @click.prevent.stop="vehicleRatingReferenceBtnDidPress">
                        "诺式车身评级标准"
                        <van-icon
                          name="arrow"
                          size="10" />
                      </div>
                    </div>

                    <div class="vehicle-rating-reference">
                      * 请联系销售顾问获取详细《鉴定报告》
                    </div>
                  </div>
                </div>
              </template>

              <!-- 诺式报告 START -->
              <div class="heading-wrapper reports-heading-wrapper">
                <h3 class="heading">
                  诺式报告
                </h3>
              </div>

              <div class="reports-wrapper">
                <reports />
              </div>

              <template v-if="reportEquipment">
                <div
                  class="heading-wrapper">
                  <h3 class="heading">
                    功能配置
                  </h3>
                </div>

                <div class="report-standard-equipment-wrapper">
                  <standard-report-equipment />
                </div>
              </template>
            </div>

            <!-- options list -->
            <template v-if="car.car.optional_configuration_images?.length">
              <div
                class="heading-wrapper">
                <h3 class="heading">
                  选装清单
                </h3>
              </div>

              <!-- options list wrapper -->
              <div
                :class="{
                  'options-list-wrapper': true,
                  'options-list-wrapper--expand': optionsListExpanded
                }">
                <div
                  ref="optionsListContent"
                  :class="{
                    'options-list__content': true,
                    'options-list__content--expanded': optionsListExpanded
                  }">
                  <template
                    v-for="(image, imageIndex) in car.car.optional_configuration_images"
                    :key="imageIndex">
                    <div
                      class="options-list-image-wrapper"
                      :data-src="image"
                      @click.prevent.stop="optionsListImageDidPress">
                      <img
                        :src="`${image}!/fw/960/rotate/auto/format/webp`"
                        :class="['options-list-image']">
                    </div>
                  </template>
                </div>
                <!--  toggle -->
                <div
                  v-if="shouldShowOptionsToggle"
                  class="options-list__toggle">
                  <div
                    class="options-list__toggle__btn"
                    @click.prevent.stop="optionsListExpanded = !optionsListExpanded">
                    <div class="options-list__toggle-btn__title">
                      {{ optionsListExpanded ? '收起选装清单' : '展开查看选装清单' }}
                    </div>
                    <van-icon :name="optionsListExpanded ? 'arrow-up' : 'arrow-down'" />
                  </div>
                </div>
                <!--/ toggle -->
              </div>
              <!--/ options list wrapper -->
            </template>
            <!--/ options list -->

            <div class="seperator" />
          </van-tab>
          <!--/ 诺式报告 -->

          <!-- 路试笔记 -->
          <template v-if="hasComments">
            <van-tab
              :name="'路试笔记'"
              :title="'路试笔记'">
              <div
                ref="commentsHD"
                class="heading-wrapper comments-heading-wrapper">
                <h3 class="heading">
                  路试笔记
                </h3>
              </div>
              <div class="comments-wrapper">
                <div
                  :class="{
                    'comments__content': true,
                    'comments__content--expanded': commentsExpanded
                  }">
                  <comments />
                </div>
                <div class="comments__toggle">
                  <div
                    class="comments__toggle__btn"
                    @click.prevent.stop="navigateToVehicleCommentsDetail">
                    <div class="comments__toggle__btn__title">
                      查看路试笔记
                    </div>
                    <van-icon
                      :name="'arrow'"
                      size="10" />
                  </div>
                </div>
              </div>
              <div class="seperator" />
            </van-tab>
          </template>
          <!--/ 路试笔记 -->

          <!-- 标准保障范畴 START -->
          <template v-if="!isMotorcycle">
            <van-tab
              :name="'保障'"
              :title="'保障'">
              <div
                ref="warrantyHD"
                :class="['heading-wrapper', 'warranty-heading-wrapper']">
                <h3 class="heading">
                  诺式保障标准版
                </h3>
              </div>
              <div
                class="warranty-wrapper">
                <warranty />
              </div>
              <div
                class="seperator" />
            </van-tab>
          </template>
          <!-- 标准保障范畴 END -->

          <!-- recommends -->
          <van-tab
            :name="'推荐'"
            :title="'推荐'">
            <div
              ref="recommendsHD"
              class="heading-wrapper recommends-heading-wrapper">
              <h3 class="heading">
                相关推荐
              </h3>
            </div>
            <template v-if="merchandise && merchandise.length">
              <div class="merchandises-wrapper">
                <div class="merchandise__hd">
                  <!-- mechandises banner -->
                  <a
                    href="https://shop16669793.m.youzan.com/v2/"
                    target="_blank">
                    <img
                      src="https://static.nuonuo.com.cn/zycmp/standard-detail-navigate-to-mall-bg-20230316.png"
                      class="merchandises__banner">
                  </a>
                  <!-- mechandises banner -->

                  <div class="merchandise__title">
                    定车啦，顺带选件车品吧～
                  </div>
                  <div class="merchandise__desc">
                    件件新测严选，不让诺粉走弯路！
                  </div>
                </div>
                <div class="merchandise__bd">
                  <template
                    v-for="(merchandiseItem, merchandiseItemIndex) in merchandise"
                    :key="merchandiseItemIndex">
                    <a
                      class="merchandise-item-wrapper"
                      :href="merchandiseItem.h5_link"
                      target="_blank">
                      <div class="merchandise-item__cover">
                        <img
                          :class="{'merchandise-item__cover-el': true}"
                          :src="`${merchandiseItem.cover_image}`">
                      </div>
                      <div class="merchandise-item__title">
                        {{ merchandiseItem.title }}
                      </div>
                      <div class="merchandise-item__price">
                        {{ merchandiseItem.price }}
                      </div>
                    </a>
                  </template>
                </div>
              </div>
            </template>
            <div class="recommends-wrapper">
              <template v-if="recommends && recommends.length > 0">
                <template
                  v-for="recommendItem in recommends"
                  :key="recommendItem.id">
                  <router-link
                    :to="`/car/${recommendItem.id}`"
                    class="recommend-item-wrapper">
                    <div
                      class="recommend-item-cover-wrapper">
                      <img
                        :src="`${recommendItem.cover}!/fw/640/rotate/auto/format/webp`"
                        class="recomment-item-cover-el">
                    </div>

                    <div class="recommend-item-title-wrapper">
                      {{ recommendItem.title }}
                    </div>

                    <div class="recommend-item-info-wrapper">
                      <div class="recommend-item-price">
                        {{ recommendItem.price.current }}
                      </div>
                      <div class="recommend-item-time">
                        {{ recommendItem.registration_date }}
                      </div>
                    </div>
                  </router-link>
                </template>
              </template>
            </div>
          </van-tab>
          <!--/ recommends -->

          <!-- about info  -->
          <!-- about info wrapper -->
          <div class="about-info-wrapper">
            <!-- about info header -->
            <div class="about-info__hd">
              <div class="about-info__title">
                工程师团队做二手车，有何特色？
              </div>
            </div>

            <!-- about info body -->
            <div class="about-info__bd">
              <!-- Yellow section - Initial checks -->
              <div class="about-info__section">
                <div class="about-info__section__hd">
                  <div class="about-info__section__title about-info__section__title--bg-yellow">
                    ■ 收车时，除了验事故、核信息，诺诺还做什么？
                  </div>
                </div>
                <div class="about-info__section__bd">
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      品相甄选
                    </div>
                    <div class="about-info__section__row__desc">
                      特别注意挑选品相优于同年份平均水平的车源，强化"二手不显旧"的入手体验
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      黑名单过滤
                    </div>
                    <div class="about-info__section__row__desc">
                      根据大量维修案例和经验积累，过滤后期成本高、故障率高的车源或车型，减少买家用车烦恼
                    </div>
                  </div>
                </div>
              </div>

              <!-- Green section - Post-arrival processes -->
              <div class="about-info__section">
                <div class="about-info__section__hd">
                  <div class="about-info__section__title about-info__section__title--bg-green">
                    ■ 回店后，除了洗干净，诺诺还做什么？
                  </div>
                </div>
                <div class="about-info__section__bd">
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      到店复鉴
                    </div>
                    <div class="about-info__section__row__desc">
                      由<span class="text-highlighted">高级鉴定师</span>再次鉴定，要拆哪就拆哪，看个通透，包括里程辦伪，以防收购同事走眼
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      道路测试
                    </div>
                    <div class="about-info__section__row__desc">
                      由<span class="text-highlighted">专职试车员</span>对动力、制动、转向、悬架、NVH表现等进行深度路试，搜集问题和故障
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      机电检查
                    </div>
                    <div class="about-info__section__row__desc">
                      由<span class="text-highlighted">维修技师</span>和<span class="text-highlighted">质检工程师</span>做机电检查，涉及渗漏、老化、故障、耗材，以及各项配置功能
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      售前整备
                    </div>
                    <div class="about-info__section__row__desc">
                      由<span class="text-highlighted">质检主管</span>汇总问题，分级并制定方案，重要/紧急的项目提前整备（不另收费），让车子到手就能投入使用
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      可选整备
                    </div>
                    <div class="about-info__section__row__desc">
                      将不影响主要功能和性能的问题做公示，买家可根据个人喜好合理支配预算
                    </div>
                  </div>
                </div>
              </div>

              <!-- Gray section - Display info -->
              <div class="about-info__section">
                <div class="about-info__section__hd">
                  <div class="about-info__section__title about-info__section__title--bg-gray">
                    ■ 上架展示，除了参数和亮点，诺诺还做什么？
                  </div>
                </div>
                <div class="about-info__section__bd">
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      真切展示
                    </div>
                    <div class="about-info__section__row__desc">
                      由<span class="text-highlighted">专业摄影师</span>每车采约一百张照片全面展示，不修图不美化，但求真实还原，所见即所得，方便异地买家远程决策
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      科学定价
                    </div>
                    <div class="about-info__section__row__desc">
                      自有<span class="text-highlighted">IT部门</span>和自研<span class="text-highlighted">行情系统</span>，结合整备、品相集团定价，加之一口价模式，您不必研究行情，也不必琢磨砍价
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      透明公示
                    </div>
                    <div class="about-info__section__row__desc">
                      提供全套<span class="text-highlighted">《诺式报告》</span>，并为您解读，提倡先搞清再掏钱，大大降低二手车的盲盒属性，减少变量
                    </div>
                  </div>
                </div>
              </div>

              <!-- Blue section - Post-sale service -->
              <div class="about-info__section">
                <div class="about-info__section__hd">
                  <div class="about-info__section__title about-info__section__title--bg-blue">
                    ■ 卖出后，诺诺还会做什么？
                  </div>
                </div>
                <div class="about-info__section__bd">
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      走眼退车
                    </div>
                    <div class="about-info__section__row__desc">
                      遇事故走眼、调表，或手续原因致无法上牌等，均履行退车承诺①
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      售后保障
                    </div>
                    <div class="about-info__section__row__desc">
                      默认包含最长一年的全国质保②，并最长可延至两年③，理赔不推诿，怎么承诺就怎么兑现
                    </div>
                  </div>
                  <div class="about-info__section__row">
                    <div class="about-info__section__row__title">
                      技术支持
                    </div>
                    <div class="about-info__section__row__desc">
                      对于不在质保范围内的故障，提供技术咨询和零件代购，帮诺粉节约开销，减少走弯路、花冤枉钱的可能
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- about info footer -->
            <div class="about-info__ft">
              <div class="about-info__footnote-wrapper">
                <div class="about-info__footnote__number">①</div>
                <div class="about-info__footnote__content">具体退车细则详见《销售合同》；</div>
              </div>
              <div class="about-info__footnote-wrapper">
                <div class="about-info__footnote__number">②</div>
                <div class="about-info__footnote__content">车龄较长的车辆会相应缩短保修期限，新能源车和仍有原厂质保的车源请详询销售，具体细则见《质保合同》；</div>
              </div>
              <div class="about-info__footnote-wrapper">
                <div class="about-info__footnote__number">③</div>
                <div class="about-info__footnote__content">延保须另购，延保方案请详询销售；</div>
              </div>
            </div>
          </div>
          <!--/ about info -->
        </van-tabs>

        <!-- branding Start -->
        <brand />
        <!-- branding End -->
      </div>
    </template>
  </div>
  <!-- car wrapper END -->
</template>

<style lang="scss" scoped>
@use './vehicle-rating.scss' as *;

.page-wrapper.page-wrapper--standard-detail {
  --tag-item-default-foreground: #212121;
  --tag-item-default-background: #E9E9E9;

  --tag-item-highlight-foreground: #8D6E0Cl;
  --tag-item-highlight-background: #FFEAC1;
}

.heading-wrapper {
  padding: 15px 10px 6px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  align-items: baseline;
  background: var(--background);
  line-height: 1;
}

.heading-wrapper .heading {
  font-size: 1.4rem;
}

.heading-wrapper .car-serial-number {
  margin-left: 5px;
  font-size: .75rem;
  color: #616161;
}

.popup-of-consultant-card {
  width: 90%;

  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
}

.standard-detail-wrapper {
  position: relative;
  padding-bottom: 100px;
  box-sizing: border-box;
}

.seperator {
  width: 100%;
  height: 2px;
  background: #f4f4f4;
  transform: scaleY(0.5);
  transform-origin: 0 100%;
}

.car-gallery-wrapper {
  position: relative;
  width: 100%;
  height: auto;
}

.car-gallery-wrapper::before {
  position: absolute;
  display: block;
  content: '';
  width: 40%;
  height: 100px;
  bottom: 0;
  right: 0;
  z-index: 100;
  background-repeat: no-repeat;
}

// 已预订
.car-gallery-wrapper.ordered::before,
.car-gallery-wrapper.early-access-sold::before {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car_cover_ordered.png');
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  bottom: 10px;
  right: 20px;
  width: 200px;
  height: 100px;
}

// 被截胡
.car-gallery-wrapper.cut-off::before {
  background-image: url('https://static.nuonuo.com.cn/zycmp/zcar-cover-cut-off.png');
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
  bottom: 10px;
  right: 0;
  width: 40%;
  height: 160px;
}

// 已售
.car-gallery-wrapper.sold::before {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_cover_sold.png');
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
  bottom: 30px;
  right: 30px;
  width: 40%;
  height: 100px;
}

// 刚到店
.car-gallery-wrapper.newbie::before,
.car-gallery-wrapper.newbie-loan-review::before {
  width: 20%;
  height: 30%;
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_cover_newbie.png');
  top: 0;
  bottom: none;
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;
}

// 刚到店 & 已预定
.car-gallery-wrapper.newbie-ordered::before {
  width: 20%;
  height: 30%;
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_cover_newbie.png');
  top: 0;
  bottom: none;
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;
}

// .car-gallery-wrapper.early-access-sold::after
.car-gallery-wrapper.newbie-ordered::after
 {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_cover_ordered.png?v=2');
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
  position: absolute;
  display: block;
  content: '';
  bottom: 20px;
  right: 20px;
  z-index: 100;
  width: 40%;
  height: 100px;
}

// 刚到店 & 已预定
.car-gallery-wrapper.newbie-sold::before {
  width: 20%;
  height: 30%;
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_cover_newbie.png');
  top: 0;
  bottom: none;
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;
}

.car-gallery-wrapper.newbie-sold::after {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_cover_sold.png?v=2');
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
  position: absolute;
  display: block;
  content: '';
  bottom: 30px;
  right: 30px;
  z-index: 100;
  width: 40%;
  height: 100px;
}

.car-gallery-wrapper {
  position: relative;
}

.gallery-placeholder {
  display: block;
  width: 100%;
}

.gallery-placeholder-el {
  display: block;
  width: 100%;
}

// new styles for car detai
.colored-bg-wrapper {
  overflow: hidden;
}

// * * * title * * *
.title-wrapper {
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 8px;
  margin-bottom: 5px;
}

.title-wrapper .title {
  vertical-align: middle;
  display: inline-block;
}

.title-wrapper .title .title-text {
  vertical-align: middle;
  font-size: 1.125rem;
  line-height: 1.225;
  color: var(--black-primary);
}

.title-wrapper .title__category-indicator {
  border-radius: 4px;
  vertical-align: middle;
  content: '自营';
  white-space: nowrap;
  display: inline-block;
  padding: 3px 6px;
  box-sizing: border-box;
  background: var(--zcar-primary);
  color: #fff;
  font-size: .6rem;
  margin-right: 6px;
  vertical-align: middle;
  line-height: 1;
}

// * * * price * * *
.price-wrapper {
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: 5px;
}

.price {
  font-size: 1.525rem;
  font-weight: bold;
  color: var(--price-primary);
  margin-right: 5px;
  margin-left: -2px;
}

.price-info-wrapper {
  display: flex;
  flex-flow: column nowrap;
}

.price-wrapper .maintenance-cost-wrapper {
  display: inline-block;
  margin-left: 2px;
  font-size: .75rem;
  color: var(--black-secondary);
}

.price-wrapper .navigator-to-vote {
  color: var(--blue-primary);
  font-size: .7rem;
  cursor: pointer;
  margin-bottom: 2px;
}

// * * * tag  * * *
.tag-wrapper {
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  user-select: none;
  align-items: center;
  cursor: pointer;
}

.tag-item {
  font-size: 0.7rem;
  padding: 1px 4px;
  margin-right: 5px;
  margin-bottom: 5px;
  background: var(--tag-item-default-background);
  color: var(--tag-item-default-foreground);
  box-sizing: border-box;
  line-height: 1;
}

.tag-item--highlight {
  color: var(--tag-item-highlight-foreground);
  background: var(--tag-item-highlight-background);
  border-color: var(--tag-item-highlight-background);
}

.tag-info-indicator__icon {
  margin-left: 2px;
  line-height: 1;
  margin-top: -1px;
}

/* New energy colors for tags */
.tag-wrapper.new-energy .tag-item {
  background: transparent;
  border-color: #212121;
  color: #212121;
}

.tag-wrapper.new-energy .tag-item--highlight {
  background: transparent;
  border-color: #101010;
  color: #101010;
  font-weight: bold;
}

// * * * price notice * * *
.car-price-notice-wrapper  {
  padding: 0 10px;
  font-size: 0.65rem;
  box-sizing: border-box;
  margin-bottom: 5px;
  color: var(--black-secondary);
}

// new energy colors
.colored-bg-wrapper.new-energy {
  color: #212121;
  background: rgb(102,175,136);
  background: linear-gradient(0deg, rgba(102,175,136,1) 0%, rgba(137,202,168,1) 30%, rgba(255,255,255,1) 100%);

  // title
  :deep(.title-wrapper .title__category-indicator) {
    background: #212121;
    color: #ffffff;
  }

  // price
  :deep(.price) {
    color: #212121;
  }

  // maintenance cost
  :deep(.maintenance-cost-wrapper) {
    display: inline-block;
    color: #212121;
  }

  // tag
  .tag-wrapper :deep(.tag-item) {
    color: #212121;
    background: transparent;
    border: 1px solid #212121;
  }

  // price notice
  :deep(.car-price-notice-wrapper) {
    color: #212121;
  }

  .navigator-to-vote {
    color: #212121;
  }

  .price-notice-wrapper {
    color: #212121;
  }
}

.mortgage-wrapper {
  width: 100%;
  background: #fff3e7;
  width: 100%;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  text-align: center;
  color: var(--price-primary);
  font-size: 0.8rem;
  &:hover {
    filter: brightness(.95);
  }
}

.mortgage-promotion-text {
  display: flex;
  align-items: baseline;
  flex-flow: row nowrap;
}

.mortgage-promotion-text .emphysis {
  font-size: 1rem;
  font-weight: bold;
  margin-right: 3px;
}

.mortgage-more {
  position: relative;
  padding-right: 1.25rem;
  font-weight: normal;
  box-sizing: border-box;
  background: #ffffff;
  padding: 5px 20px;
  border-radius: 9999px;
}

.mortgage-wrapper:hover {
  filter: brightness(.9);
}

.car-loans-desc {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  text-align: center;
  color: var(--price-primary);
  font-size: 0.75rem;
}

.car-loans-desc div span.strong {
  font-size: .9rem;
  font-weight: bold;
}

.car-loans-desc div span {
  margin: 0;
}

.car-loans-desc__em {
  font-size: .9rem;
  font-weight: bold;
  margin-right: 2px;
}

.car-loans-detail-btn {
  position: relative;
  font-weight: normal;
  box-sizing: border-box;
}

.anchor-menu-wrapper {
  :deep(.van-sticky.van-sticky--fixed) {
    box-shadow:  0 0px 10px  rgba(0,0,0,.2);
  }

  :deep(.van-tabs__line) {
    display: none;
  }

  :deep( .van-tab__text) {
    font-size: .85rem;
  }

  :deep(.van-tab--active .van-tab__text) {
    box-sizing: border-box;
    padding: 13px 5px 7px;
    font-size: 1.115rem;
    font-weight: bold;
    color: var(--black-primary);
    border-bottom: 3px solid var(--zcar-primary);
  }

  :deep(.van-tabs__nav--line) {
    padding-left: 0px!important;
    padding-right: 0px!important;
    align-items: baseline;
    padding-bottom: 0!important;
  }
}

.meta-info-wrapper,
.description-wrapper,
.reports-wrapper,
.warranty-wrapper,
.comments-wrapper,
.pic-summary-wrapper,
.report-standard-equipment-wrapper,
.merchandises-wrapper {
  padding: 5px 10px 8px;
  box-sizing: border-box;
  width: 100%;
  background: var(--background);
}

.meta-info-wrapper {
  // padding-bottom: 10px
}

.comments-wrapper,
.pic-summary-wrapper,
.recommends-wrapper {
  padding: 0;
}

.meta-info-heading-wrapper,
.meta-info-wrapper,
.consultant-wrapper,
.description-heading-wrapper,
.description-wrapper,
.reports-heading-wrapper,
.reports-wrapper,
.warranty-heading-wrapper,
.pic-summary-heading-wrapper,
.pic-summary-wrapper,
.comments-heading-wrapper,
.comments-wrapper,
.recommends-heading-wrapper,
.recommends-wrapper,
.merchandises-wrapper {
  z-index: 0;
}

.navigator-to-agreement {
  position: fixed;
  bottom: 200px;
  right: 15px;
  font-size: .7rem;
  border-radius: 10px;
  color: #fff;
  box-shadow: 0px 0px 20px 0px var(--blue-primary);
  background: var(--blue-primary);
  z-index: 500;
  text-align: center;
  width: 50px;
  height: 50px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
    filter: brightness(.9);
  }
}

.consultant-wrapper {
  box-sizing: border-box;
  width: 100%;
  background: var(--background);
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 200;
  padding-bottom: env(safe-area-inset-bottom, 20px);
  box-shadow: 0px -1px 5px 0px rgba(0,0,0,.1);
}

// consultant block
.consultant {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
}

.consultant-info-wrapper {
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.consultant-avatar-wrapper {
  flex: 0 0 auto;
  margin-right: 6px;
}

.consultant-avatar-el {
  display: block;
  width: 100%;
  margin: 0 auto;
  border-radius: 50%;
  max-width: 35px;
  max-height: 35px;
}

.consultant-info {
  flex: 3;
}

.consultant-info .consultant-title {
  font-size: .9rem;
  color: var(--black-secondary);
  font-weight: 400;
}

.consultant-info .consultant-name {
  font-size: 1.025rem;
  color: #205dcd;
}

.consultant-action-wrapper {
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}

.consultant-call-btn {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  box-sizing: border-box;
  font-size: .9rem;
  color: #f76a00;
  background: #FFEDE0;
  text-decoration: none!important;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  border-radius: 9999px;

  &:link
  &:active,
  &:visited {
    color: #f76a00;
  }

  &:hover {
    filter: brightness(.9);
  }
}

.call-consultant-btn-icon {
  margin-right: 5px;
  width: 18px;
  height: 18px;
}

.call-consultant-btn-text {
  white-space: nowrap;
  font-weight: bold;
  font-size: 1rem;
}

.consultant-msg-btn-wrapper {
  display: flex;
  align-items: center;
  margin-left: auto;
  box-sizing: border-box;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  margin-right: 15px;
  border-radius: 9999px;
  background-color: #E3F1FF;

  &:hover {
    filter: brightness(.9);
    cursor: pointer;
  }

  .consultant-msg-icon-wrapper {
    line-height: 1;
  }

  .consultant-msg-icon {
    width: 20px;
    height: 20px;
    fill: #027BFF;
    margin-right: 5px;
  }

  .consultant-msg-text {
    color: #027BFF;
    font-size: 1rem;
    font-weight: bold;
  }
}

.consultant-action-button-order-same-car {
  flex-flow: row nowrap;
  align-items: center;
  color: #f76a00;
  background: #FFEDE0;
  height: 40px;
  font-weight: bold;
  line-height: 40px;
  padding: 0px 30px;
  border-radius: 9999px;
  margin-right: 10px;
  min-width: 100px;
  text-align: center;
  font-size: .9rem;
  cursor: pointer;
}

// recommends
.recommends-wrapper {
  display: flex;
  flex-flow: row wrap;
  box-sizing: border-box;
}

.recommend-item-wrapper {
  flex-basis: 50%;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 20px;

  &:hover {
    filter: brightness(.9);
    cursor: pointer;
  }

  &:nth-child(odd) {
    padding-left: 10px;
    padding-right: 5px;
  }

  &:nth-child(even) {
    padding-left: 5px;
    padding-right: 10px;
  }
}

.recommend-item-cover-wrapper {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  height: auto;
  position: relative;

  &::before {
    content: '';
    display: block;
    padding-bottom: calc(100% / 3 * 2);
    box-sizing: border-box;
    width: 100%;
  }
}

.recomment-item-cover-el {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.recommend-item-title-wrapper {
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--black-primary);
  margin: 5px 0 1px 0;
}

.recommend-item-info-wrapper {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: baseline;
}

.recommend-item-price {
  font-size: 1rem;
  color: var(--price-primary);
  margin-left: -3px;
}

.recommend-item-time {
  font-size: .9rem;
  color: var(--black-secondary);
}

// recommends
.recommends-wrapper {
  display: flex;
  flex-flow: row wrap;
  box-sizing: border-box;
}

.recommend-item-wrapper {
  flex-basis: 50%;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 20px;

  &:hover {
    filter: brightness(.9);
    cursor: pointer;
  }

  &:nth-child(odd) {
    padding-left: 10px;
    padding-right: 5px;
  }

  &:nth-child(even) {
    padding-left: 5px;
    padding-right: 10px;
  }
}

.recommend-item-cover-wrapper {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  height: auto;
  position: relative;

  &::before {
    content: '';
    display: block;
    padding-bottom: calc(100% / 3 * 2);
    box-sizing: border-box;
    width: 100%;
  }
}

.recomment-item-cover-el {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.recommend-item-title-wrapper {
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--black-primary);
  margin: 5px 0 1px 0;
}

.recommend-item-info-wrapper {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: baseline;
}

.recommend-item-price {
  font-size: 1rem;
  color: var(--price-primary);
  margin-left: -3px;
}

.recommend-item-time {
  font-size: .9rem;
  color: var(--black-secondary);
}

// recommends
.recommends-wrapper {
  display: flex;
  flex-flow: row wrap;
  box-sizing: border-box;
}

.recommend-item-wrapper {
  flex-basis: 50%;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 20px;

  &:hover {
    filter: brightness(.9);
    cursor: pointer;
  }

  &:nth-child(odd) {
    padding-left: 10px;
    padding-right: 5px;
  }

  &:nth-child(even) {
    padding-left: 5px;
    padding-right: 10px;
  }
}

.recommend-item-cover-wrapper {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  height: auto;
  position: relative;

  &::before {
    content: '';
    display: block;
    padding-bottom: calc(100% / 3 * 2);
    box-sizing: border-box;
    width: 100%;
  }
}

.recomment-item-cover-el {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.recommend-item-title-wrapper {
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--black-primary);
  margin: 5px 0 1px 0;
}

.recommend-item-info-wrapper {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: baseline;
}

.recommend-item-price {
  font-size: 1rem;
  color: var(--price-primary);
  margin-left: -3px;
}

.recommend-item-time {
  font-size: .9rem;
  color: var(--black-secondary);
}

@media (min-width: 640px) {
  .popup-of-consultant-card {
    max-width: 520px;
  }

  .car-price-notice-wrapper {
    font-size: 0.7rem;
  }

  .heading-wrapper {
    padding: 10px 10px 8px;
  }

  .meta-info-wrapper,
  .description-wrapper,
  .reports-wrapper,
  .warranty-wrapper,
  .comments-wrapper,
  .pic-summary-wrapper,
  .recommends-wrapper,
  .report-standard-equipment-wrapper {
    padding: 5px 10px 8px;
    box-sizing: border-box;
    width: 100%;
    background: var(--background);
  }

  .comments-wrapper,
  .pic-summary-wrapper,
  .recommends-wrapper {
    padding: 5px 0 0;
  }

  .consultant-action-button-order-same-car:hover {
    background: var(--btn-orange-primary-pressed);
  }

  .consultant-avatar-wrapper {
    margin-right: 10px;
  }

  .consultant-avatar-el {
    max-width: 45px;
    max-height: 45px;
  }

  .consultant-wrapper {
    padding-bottom: unset;
    box-shadow: unset;
  }

  .consultant {
    display: flex;
    flex-flow: row nowrap;
    max-width: 640px;
    margin: 0 auto;
    box-shadow: 0px -1px 5px 0px rgba(0,0,0,.1);
  }

  .consultant-call-btn,
  .consultant-msg-btn-wrapper,
  .consultant-action-button-order-same-car {
    line-height: 40px;
    height: 40px;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 20px;
  }

  .consultant-msg-btn-wrapper {
    margin-right: 15px;
  }

  .consultant-action-button-order-same-car {
    min-width: 250px;
  }

  .price-wrapper .price {
    font-size: 1.725rem;
  }
}

// option list image wrapper
.options-list-wrapper {
  position: relative;
  overflow: hidden;
  background: transparent;
  z-index: 0;
}

.options-list-wrapper::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 200px;
  width: 100%;
  background: linear-gradient(to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%);
  z-index: 100;
}

.options-list-wrapper.options-list-wrapper--expand::after {
  display: none;
}

.options-list__content {
  height: 500px;
}

.options-list__content.options-list__content--expanded {
  height: unset;
}

.options-list-image-wrapper {
  padding: 15px;
  box-sizing: border-box;
  background: #f1f1f3;
  width: 100%;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.options-list-image {
  display: block;
  width: 100%;
  margin: 0 auto;
}

.options-list__toggle {
  position: absolute;
  width: 100%;
  z-index: 200;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.options-list__toggle__btn {
  margin-bottom: 10px;
  font-size: .85rem;
  font-weight: bold;
  padding: 6px 30px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: #027BFF;
  position: relative;
  border-radius: 9999px;
  background: #FFFFFF;
  cursor: pointer;

  &::after {
    display: block;
    position: absolute;
    width: 200%;
    height: 200%;
    content: '';
    transform: scale(0.5);
    top: 0;
    left: 0;
    border-radius: 9999px;
    transform-origin: 0 0;
    box-shadow: 0 2px 5px 0px rgba(0, 0, 0, 0.2);
  }
}

.options-list__toggle-btn__title {
  margin-right: 5px;
}

// comments
.comments-wrapper {
  position: relative;
  overflow: hidden;
  background: transparent;
  z-index: 0;
}

.comments-wrapper::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 200px;
  width: 100%;
  background: linear-gradient(to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%);
  z-index: 100;
}

.comments__content {
  height: 500px;
}

.comments__content.comments__content--expanded {
  height: unset;
}

.comments__toggle {
  position: absolute;
  width: 100%;
  z-index: 200;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.comments__toggle__btn {
  margin-bottom: 10px;
  font-size: .85rem;
  font-weight: bold;
  padding: 6px 30px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: #027BFF;
  position: relative;
  border-radius: 9999px;
  background: #FFFFFF;
  cursor: pointer;

  &::after {
    display: block;
    position: absolute;
    width: 200%;
    height: 200%;
    content: '';
    transform: scale(0.5);
    top: 0;
    left: 0;
    border-radius: 9999px;
    transform-origin: 0 0;
    box-shadow: 0 2px 5px 0px rgba(0, 0, 0, 0.2);
  }
}

.comments__toggle__btn__title {
  margin-right: 5px;
}

// merchandise
.merchandises-wrapper {
  flex-flow: row wrap;
  margin-bottom: 20px;
}

.merchandises__banner {
  display: block;
  width: 100%;
  margin: 0 0 8px 0;
}

.merchandise__title {
  font-size: 1.1rem;
  background: #D23333;
  color: #ffffff;
  padding: 4px 5px;
  box-sizing: border-box;
  margin-bottom: 5px;
}

.merchandise__desc {
  font-size: 1rem;
  box-sizing: border-box;
  color: #808080;
  margin-bottom: 10px;
}

.merchandise__bd {
  display: flex;
  flex-flow: row wrap;
}

.merchandise-item-wrapper {
  flex: 0 0 calc(50% - 5px);
  margin-right: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.merchandise-item-wrapper:nth-child(2n) {
  margin-right: 0;
}

.merchandise-item__cover {
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: 6px;

  &::before {
    content: '';
    display: block;
    padding-bottom: 100%;
    box-sizing: border-box;
    width: 100%;
  }
}

.merchandise-item__cover-el {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.merchandise-item__title {
  font-size: 1rem;
  margin-bottom: 2px;
  color: var(--black-primary);
}

.merchandise-item__price {
  font-size: 1rem;
  color: var(--price-primary);
}

// about info
/* about info styles */
.about-info-wrapper {
  padding: 0 2.5px;
  box-sizing: border-box;
}

.about-info__hd {
  margin-bottom: 7.5px;
}

.about-info__title {
  text-align: center;
  padding: 3px 0;
  font-size: 15px;
  background-color: #844342;
  color: #ffffff;
}

.about-info__bd {
  margin-bottom: 5px;
}

.about-info__section {
  margin-bottom: 7.5px;
}

.about-info__section__title {
  padding: 3px 5px;
  box-sizing: border-box;
  font-size: .9rem;
  margin: 1px 0;
  color: #212121;
}

.about-info__section__row {
  padding: 5px 3px;
  box-sizing: border-box;
  background-color: #F2F2F2;
  display: flex;
  margin-bottom: 1px;
}

.about-info__section__row:last-child {
  margin-bottom: 0;
}

.about-info__section__row__title {
  font-size: .9rem;
  color: #413E3F;
  margin-right: 5px;
  flex: 0 0 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 3px solid #F7C30F;
}

.about-info__section__row__desc {
  font-size: .85rem;
  color: #616161;
  flex: 1;
  padding-left: 3px;
}

/* Background colors for different sections */
.about-info__section__title--bg-yellow {
  background: #FFE799;
}

.about-info__section__title--bg-green {
  background: #C7DEB4;
}

.about-info__section__title--bg-gray {
  background: #D6DCE3;
}

.about-info__section__title--bg-blue {
  background: #BDD7EE;
}

/* Highlighted text */
.text-highlighted {
  color: #146DB0;
}

/* Footnotes */
.about-info__footnote-wrapper {
  padding: 0 5px;
  box-sizing: border-box;
  font-size: .8rem;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  margin-bottom: 4px;
}

.about-info__footnote__number {
  margin-right: 5px;
}

// @media min-width: 640px;
@media (min-width: 640px) {
  .heading-wrapper .heading {
    font-size: 1.3rem;
  }

  .options-list-image-wrapper {
    padding: 10px;
  }

  .merchandise-item__cover:hover {
    filter: brightness(.9);
  }

  .about-info__section__row__title {
    flex: 0 0 120px;
  }

  .vehicle-rating {
    padding: 0 20px;
  }

  .rating-level {
    margin: 0 auto 30px;
  }

  .rating-level__items {
    margin: 10px auto 0;
  }

  .rating-level__item {
    width: 40px;
    height: 40px;
    font-size: 13px;
    margin: 0 5px;
  }

  .rating-level__item-wrapper--active .rating-level__item {
    width: 60px;
    height: 60px;
    font-size: 18px;
  }

  .rating-level__item-desc {
    margin-top: 5px;
    font-size: 12px;
  }

  .rating-level__desc {
    font-size: 12px;
  }
}

// @media perfers-color-scheme: dark
@media (prefers-color-scheme: dark) {
  .page-wrapper.page-wrapper--standard-detail {
    --tag-item-default-foreground: #D9D9D9;
    --tag-item-default-background: #212121;

    --tag-item-highlight-foreground: #FFEAC1;
    --tag-item-highlight-background: #313131;
  }

  .tag-item {
    color: #ddfcfe;
    background: #272727;
    border-color: #272727;
  }

  .tag-item--highlight {
    color: #ffeac1;
    background: #313131;
    border-color: #313131;
  }

  .tag-wrapper.new-energy .tag-item {
    background: transparent;
    border-color: #ffffff;
    color: #ffffff;
  }

  .tag-wrapper.new-energy .tag-item--highlight {
    background: transparent;
    border-color: #ffffff;
    color: #ffffff;
    font-weight: bold;
  }

  .colored-bg-wrapper.new-energy  {
    background: linear-gradient(0deg, rgb(19, 134, 75) 0%, rgb(191, 251, 219) 100%);

    .title-wrapper .title .title-text {
      color: #0A0A0A;
    }
  }

  .mortgage-wrapper {
    color: #F44F00;
    background: #1A1A1A;
  }

  .mortgage-more {
    background: #101010;
  }

  .price-notice-wrapper {
    color: #D9D9D9;
  }

  .anchor-menu-wrapper {
    :deep(.van-tabs__nav--line) {
      background: var(--background);
    }
  }

  .seperator {
    background: #313131;
  }

  .navigator-to-agreement {
    background: #1A1A1A;
    box-shadow: unset;
    color: var(--blue-primary);
  }

  .navigator-to-zcar-index {
    background: #1A1A1A;
    box-shadow: unset;
    color: var(--zcar-primary);
  }

  .consultant {
    border-top: 1px solid #313131;
  }

  :deep(.van-tab__text) {
    color: #d2d2d2;
  }

  .consultant-info .consultant-name {
    color: var(--blue-primary);
  }

  .consultant-msg-btn-wrapper {
    border-color: #272727;
    background: #272727;
  }

  .consultant-call-btn {
    border-color: #272727;
    background: #272727;
  }

  .options-list-item-wrapper {
    background: #1A1A1A;
  }

  .navigator-to-standard-list {
    background: #1A1A1A;
    box-shadow: unset;
  }

  .options-list__toggle__btn,
  .comments__toggle__btn {
    background: #272727;
    border: none;
  }

  .options-list-wrapper::after,
  .comments-wrapper::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background: linear-gradient(to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 100%);
    z-index: 100;
  }

    /* about info */
    .about-info__title {
    background-color: #291514;
    color: #d9d9d9
  }

  .about-info__section__title.about-info__section__title--bg-yellow {
    /* background: #383016; */
    background: #1F1F1F;
  }

  .about-info__section__title.about-info__section__title--bg-green {
    /* background: #363c31; */
    background: #1F1F1F;
  }

  .about-info__section__title.about-info__section__title--bg-gray {
    /* background: #161f29; */
    background: #1F1F1F;
  }

  .about-info__section__title.about-info__section__title--bg-blue {
    /* background: #041928; */
    background: #1F1F1F;
  }

  .about-info__section__title {
    color: #D9D9D9;
  }

  .about-info__section__row {
    background: #0F0F0F;
  }

  .about-info__section__row__title {
    color: #F0F0F0;
    border-color: #5b4806;
    flex: 0 0 120px;
  }

  .about-info__section__row__desc {
    color: #D9D9D9;
    font-size: .9rem;
  }

  .about-info__section__row__desc .text-highlighted {
    color: #4fabec;
  }

  .rating-level__item::after {
    border-color: #212121;
  }

  .rating-level__item-wrapper--active::before {
    border-top-color: #D9D9D9;
  }

  .consultant-action-button-order-same-car {
    background: #1F1F1F;
  }
}

// @media prefers-color-scheme: light & min-width: 640px
@media (prefers-color-scheme: light) and (min-width: 640px) {
  .options-list__toggle__btn:hover,
  .comments__toggle__btn:hover {
    background: #F1F1F1;
  }
}

// @media persfers-color-scheme: dark & min-width: 640px
@media (prefers-color-scheme: dark) and (min-width: 640px) {
  .options-list__toggle__btn:hover,
  .comments__toggle__btn:hover {
    background: #1F1F1F;
  }
}

.vehicle-comments-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.vehicle-comments-btn {
  margin-bottom: 10px;
  font-size: .85rem;
  font-weight: bold;
  padding: 6px 30px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: #027BFF;
  position: relative;
  border-radius: 9999px;
  background: #FFFFFF;
  cursor: pointer;

  &::after {
    display: block;
    position: absolute;
    width: 200%;
    height: 200%;
    content: '';
    transform: scale(0.5);
    top: 0;
    left: 0;
    border-radius: 9999px;
    transform-origin: 0 0;
    box-shadow: 0 2px 5px 0px rgba(0, 0, 0, 0.2);
  }
}

.vehicle-comments-btn__title {
  margin-right: 5px;
}

// ... existing code ...
@media (prefers-color-scheme: dark) {
  .vehicle-comments-btn {
    background: #272727;
    border: none;
  }
}

// ... existing code ...
@media (prefers-color-scheme: dark) and (min-width: 640px) {
  .vehicle-comments-btn:hover {
    background: #1F1F1F;
  }
}

/* Tags detail popup styles - 2025.06.21 */
.tags-detail-popup {
  width: 100%;
  min-height: 70%;
  overflow-y: auto;
  box-sizing: border-box;
}

@media (prefers-color-scheme: dark) {
  .tags-detail-popup {
    background: #1A1A1A;
  }
}

.tags-detail-close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  z-index: 10;
}

.tags-detail-container {
  width: 100%;
  margin: 0 auto;
}

.tags-detail-body {
  width: 100%;
}

.tags-detail-header {
  border-bottom: 1px solid var(--border-primary, #ebedf0);
  padding: 10px;
}

.tags-detail-body-content {
  padding: 10px;
}

.tags-detail-header-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: var(--black-primary);
}

.tags-detail-item {
  margin-bottom: 15px;
  padding: 0 5px;
}

.tags-detail-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.tags-detail-item-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: var(--zcar-primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}

.tags-detail-item-title {
  font-weight: bold;
  font-size: 1rem;
  color: var(--black-primary);
}

.tags-detail-item-content {
  padding-left: 23px;
}

.tags-detail-item-desc {
  font-size: .9rem;
  color: var(--black-secondary);
  line-height: 1.5;
  white-space: pre-wrap;
}

.tag-info-indicator__icon {
  margin-left: 2px;
  // color: var(--black-secondary);
  line-height: 1;
  margin-top: -1px;
}

/* Tag list styling */
.tag-wrapper {
  display: flex;
  flex-wrap: wrap;
  user-select: none;
}

.tag-item {
  font-size: 0.65rem;
  padding: 2px 4px;
  margin-right: 5px;
  margin-bottom: 5px;
  border: 1px solid var(--tag-item-default-background);
  background: var(--tag-item-default-background);
  color: var(--tag-item-default-foreground);
  box-sizing: border-box;
}

.tag-item--highlight {
  color: var(--tag-item-highlight-foreground);
  background: var(--tag-item-highlight-background);
  border-color: var(--tag-item-highlight-background);
}

/* New energy colors */
.tag-wrapper.new-energy .tag-item {
  background: transparent;
  border-color: #212121;
  color: #212121;
}

.tag-wrapper.new-energy .tag-item--highlight {
  background: transparent;
  border-color: #101010;
  color: #101010;
  font-weight: bold;
}

/* Dark mode adjustments */
@media (prefers-color-scheme: dark) {
  .tag-item {
    background: #272727;
    border-color: #272727;
    color: #ddfcfe;
  }

  .tag-item--highlight {
    background: #313131;
    border-color: #313131;
    color: #ffeac1;
  }

  .tag-wrapper.new-energy .tag-item {
    background: transparent;
    border-color: #ffffff;
    color: #ffffff;
  }

  .tag-wrapper.new-energy .tag-item--highlight {
    background: transparent;
    border-color: #ffffff;
    color: #ffffff;
  }
}

.price-notice-wrapper {
  width: 100%;
  font-size: .7rem;
  line-height: 1;
  box-sizing: border-box;
  color: var(--black-secondary);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.price-notice-wrapper .price-notice__info-delimiter {
  margin: 0 4px;
}

.price-notice__info-cell {
  font-size: 0.7rem;
}

.price-info-wrapper {
  display: flex;
  flex-flow: column nowrap;
}

@media (min-width: 640px) {
  .tags-detail-container {
    width: 640px;
  }

  .tag-item {
    padding: 3px 10px;
  }

  .title-wrapper .title .title-text {
    font-size: 1.125rem;
  }
}

@media (prefers-color-scheme: dark) {
  .tags-detail-header {
    border-color: #313131;
  }
}

</style>
